'use client';

import { TSupportedOrganisationIdentityTypeCode } from '@verifime/utils';
import { TFormFieldsAndRulesV3 } from '../Form';
import useAddEntity from './useAddEntity';
import { wizardOrganisationFormFieldsAndRules } from './utils';

type TUseAddEntity = Parameters<typeof useAddEntity>[0];

export default function useAddOrganisationEntity<
  OrganisationTypeCode extends TSupportedOrganisationIdentityTypeCode,
>({
  organisationTypeCode,
  extraFormFieldsAndRules = {},
  ...props
}: {
  organisationTypeCode: OrganisationTypeCode;
  extraFormFieldsAndRules?: TFormFieldsAndRulesV3;
} & Omit<TUseAddEntity, 'initialFormFieldsAndRules' | 'initialAddresses'>) {
  return useAddEntity({
    initialFormFieldsAndRules: {
      ...wizardOrganisationFormFieldsAndRules[organisationTypeCode].basic,
      ...extraFormFieldsAndRules,
    },
    initialAddresses: wizardOrganisationFormFieldsAndRules[organisationTypeCode].addresses,
    ...props,
  });
}
